<div class="main-container">
   <!-- Client-specific background image (from theme.css variable) -->
   <div class="landing-background-image"></div>
   
   <!-- Client-specific background video (from theme.css --landing-bg-video variable) -->
   <video *ngIf="showClientVideo && clientVideoUrl" id="clientBgVideo" autoplay loop muted playsinline preload="auto" 
          class="video-background client-video" [src]="clientVideoUrl"
          (canplay)="$any($event.target).play()"
          (error)="showClientVideo=false">
      Your browser does not support the video tag.
   </video>
   
   <!-- Fallback video when no client is selected -->
   <video *ngIf="showVideoBackground && !showClientVideo" id="bgVideo" autoplay loop muted playsinline preload="auto" class="video-background fallback-video">
      <source src="assets/videos/landing_bg.mp4" type="video/mp4" />
      Your browser does not support the video tag.
   </video>
   
   <div class="container">
      <!-- Click-capturing backdrop shown when any dropdown is open -->
      <div class="overlay-backdrop" *ngIf="isClientDropdown || isStudyDropdown"
           (click)="$event.stopPropagation(); isClientDropdown=false; isStudyDropdown=false">
      </div>
      <div class="module-container">
         <div class="drop-down-container">
            <div class="empty">
               <ng-container *ngIf="!isSuperAdmin; else superAdmin">
                  <div class="client-icon" *ngIf="hasSingleClient">
                  <img *ngIf="clientLogo" [src]="clientLogo" [alt]="ClientName" class="client-logo" />
                  </div>
                  <div class="client-dropdown" *ngIf="!hasSingleClient">
                     <div class="client-dropdown-study" [ngClass]="{'open': isClientDropdown}" (click)="hasSingleClient ? '' : openClientDropdown()" DocumentClick
                        (DocumentClicked)="this.isClientDropdown=false">
                        <div class="client-dropdown-study-txt"
                           [ngStyle]="{'font-style':ClientName!='Choose Client'?'normal':'italic'}">
                           <span>{{ClientName}}</span>

                        </div>
                        <div class="client-dropdown-study-img" *ngIf="!hasSingleClient && ClientName!=''">
                           <div class="client-dropdown-img"
                              [ngClass]="{ 'rotate-icon': isClientDropdown && uniqueClientNamescount>0 }"></div>

                        </div>

                     </div>
                     <div class="client-dropdown-list" [ngClass]="{'show' : isClientDropdown}">
                        <div class="custom-report-list-search"
                           [ngStyle]="{'display':uniqueClientNamescount>10?'flex':'none'}">
                           <div class="client-search-block" title="Search Client">
                              <input type="search" [(ngModel)]="Clientsearchtxt" class="search-input-client"
                                 placeholder="Search  Client" (click)="$event.stopPropagation()">
                           </div>
                        </div>
                        <div class="client-dropdown-list-scroll">
                           <div class="client-dropdown-names"
                              *ngFor="let item of uniqueClientNames | search: Clientsearchtxt:['clientName']"
                              (click)="ClientNameSelectclick(item.clientName)">
                              <span title="{{item.clientName}}"> {{item.clientName}} </span>
                           </div>

                        </div>

                     </div>


                  </div>
               </ng-container>
               <ng-template #superAdmin>
                  <div class="client-dropdown">
                     <div class="client-dropdown-study" [ngClass]="{'open': isClientDropdown}" (click)="openClientDropdown()" DocumentClick
                        (DocumentClicked)="this.isClientDropdown=false">
                        <div class="client-dropdown-study-txt"
                           [ngStyle]="{'font-style':ClientName!='Choose Client'?'normal':'italic'}">
                           <span>{{ClientName}}</span>

                        </div>
                        <div class="client-dropdown-study-img">
                           <div class="client-dropdown-img"
                              [ngClass]="{ 'rotate-icon': isClientDropdown && uniqueClientNamescount>0 }"></div>

                        </div>

                     </div>

                     <div class="client-dropdown-list" [ngClass]="{'show' : isClientDropdown}">
                        <div class="custom-report-list-search"
                           [ngStyle]="{'display':uniqueClientNamescount>10?'flex':'none'}">
                           <div class="client-search-block" title="Search Client">
                              <input type="search" [(ngModel)]="Clientsearchtxt" class="search-input-client"
                                 placeholder="Search  Client" (click)="$event.stopPropagation()">
                           </div>
                        </div>
                        <div class="client-dropdown-list-scroll">
                           <div class="client-dropdown-names"
                              *ngFor="let item of uniqueClientNames | search: Clientsearchtxt:['clientName']"
                              (click)="ClientNameSelectclick(item.clientName)">
                              <span title="{{item.clientName}}"> {{item.clientName}} </span>
                           </div>

                        </div>

                     </div>

                  </div>
               </ng-template>
            </div>
            <div class="empty">
               <!-- Client Studies Dropdown -->
               <ng-container>
                  <div class="client-dropdown" *ngIf="ClientName!='' && ClientName!='Choose Client'">
                     <div class="client-dropdown-study" [ngClass]="{'open': isStudyDropdown}" (click)="$event.stopPropagation(); uniqueClientStudiescount>1 ? openStudyDropdown() : null" DocumentClick
                        (DocumentClicked)="this.isStudyDropdown=false">
                        <div class="client-dropdown-study-img" *ngIf="StudyName!=''">
                           <div class="client-study-dropdown-img"></div>
                        </div>
                        <div class="client-dropdown-study-txt" [title]="StudyName"
                           [ngStyle]="{'font-style':StudyName!='Choose Study'?'normal':'italic'}">
                            {{ StudyName.length > 15 ? (StudyName | slice:0:15) + '...' : StudyName }}
                        </div>
                        <div class="client-dropdown-study-img" *ngIf="StudyName!='' && uniqueClientStudiescount>1">
                           <div class="client-dropdown-img"
                              [ngClass]="{ 'rotate-icon': isStudyDropdown && uniqueClientStudiescount>0 }"></div>
                        </div>
                     </div>
                     <div class="client-dropdown-study-list" [ngClass]="{'show' : isStudyDropdown}" (click)="$event.stopPropagation()">
                        <div class="custom-report-list-search"
                           [ngStyle]="{'display':uniqueClientStudiescount>10?'flex':'none'}">
                           <div class="client-search-block" title="Search Study">
                              <input type="search" [(ngModel)]="Studysearchtxt" class="search-input-client"
                                 placeholder="Search Study" (click)="$event.stopPropagation()">
                           </div>
                        </div>
                        <div class="client-dropdown-list-scroll">
                           <div class="client-dropdown-names"
                              *ngFor="let item of uniqueClientStudies | search: Studysearchtxt:['studyName']"
                              (click)="$event.stopPropagation(); StudyNameclick(item.studyName)">
                              <span title="{{item.studyName}}"> {{item.studyName}} </span>
                           </div>
                        </div>
                     </div>
                  </div>
               </ng-container>
            </div>
         </div>
         <div class="module-options" *ngIf="!modulesRemoved && ClientName && ClientName !== 'Choose Client'">
           <div class="menu-item" *ngFor="let item of modules; let i = index"
               [ngStyle]="{'display': item.is_active ? 'flex' : 'none'}"
               [ngClass]="{'clickable': item.access, 'selected': item.is_selected}" 
               (click)="item.access ? moduleSelected(item) : null">
               <span class="text-overlay" [ngStyle]="{'color': item.is_selected ? '#000' : '#fff'}" 
                     style="display: flex; align-items: center; gap: 15px;">
                  <!-- {{ item.moduleName == 'ARK' ? 'Ask me anything' : item.moduleName | uppercase }} -->
                    {{ 
                     item.moduleName == 'ARK' 
                        ? 'Ask me anything' 
                        : item.moduleName == 'Report Generator'
                           ? 'US BRAND PERCEPTION REPORT'
                           : item.moduleName == 'Mid Year Report'
                              ? 'MID YEAR REPORT'
                              : (item.moduleName | uppercase) 
                     }}
                  <img *ngIf="item.moduleName != SnapShotName" src="../../../../assets/images/aesthetics/Expand.svg" alt="Expand Image" 
                       style="width: 16px; height: 16px; padding-bottom: 4px;" />
               </span>

               <!-- Changed from <img> to <div> to use CSS variable from theme.css -->
               <img src="../../../../assets/images/aesthetics/moduleHoverSelect_New.svg" alt="Hover Image" class="hover-image" />
               <img *ngIf="item.is_selected" [src]="getModuleHoverImage()" alt="Selected" class="click-image" />
            </div>
         </div>
          <!-- <div class="maintainance-text" >
            <img src="../../../../assets/images/common/alert.svg" alt="alert Image" class="alert-image" />
            <span class="tool-maintenance-text">Explorer+ will be under maintenance on Monday starting from 10:00-11:00 AM IST. Apologies for inconvenience caused.</span>
         </div> -->
      </div>

      <div class="sub-container">
         <div class="header">
            <div *ngIf="AlertAccess && showBellOnRoute" class="settings-icon notification-icon" [class.active]="hasNewNotifications" (click)="toggleNotificationPanel()" DocumentClick
               (DocumentClicked)="showNotificationPanel = false">
               <img [src]="hasNewNotifications ? '../../../../assets/images/aesthetics/notification_active1.svg' : '../../../../assets/images/aesthetics/notification_normal1.svg'" alt="Alert Notification"/>
            </div>
            <div class="settings-icon" [class.active]="isSettingToggle" (click)="isSettingToggle = !isSettingToggle" DocumentClick
               (DocumentClicked)="isSettingToggle = false">
               <img
                  [src]="!isSettingToggle ? 'assets/images/aesthetics/settings_icon.svg' : 'assets/images/aesthetics/SettingsIcon-click.svg'"
                  alt="Settings Icon" [class.rotate]="isSettingToggle" />
            </div>
            <div class="settingDropdown" [ngClass]="{'show' : isSettingToggle, 'hide' : !isSettingToggle}">
               <ng-container *ngIf="isSettingToggle">
                  <ng-container *ngFor="let option of SettingList">
                     <div class="setting-option" *ngIf="option.hasAccess && (isSuperAdmin || option.value === 'Logout' || option.value === 'alertManagement')" (click)="onOptionClick(option.value)">
                        <img [src]="option.iconClass.includes('/') ? 'assets/images/' + option.iconClass + '.svg' : 'assets/images/aesthetics/' + option.iconClass + '.svg'"
                           alt="option.displayLabel" />
                        <div class="settingOptionName"> {{ option.displayLabel }} </div>
                     </div>
                  </ng-container>
               </ng-container>
            </div>
         </div>
         <div class="sub-content">
            <div class="body" *ngIf="!isModuleSelected && !isModuleDirty">
               <div class="logo-block">
                  <div class="logo-sub-block">
                     <div class="logo-txt">
                        <img src="assets/images/aesthetics/Exp_logo.svg" alt="Spade Text" />
                     </div>
                  </div>
               </div>
               <div class="logo-txt-block">
                  <div class="welcome-content">
                     <div class="welcome-txt">
                        Welcome back, <span class="username">{{userName}}</span>
                     </div>
                     <div class="static-txt" *ngIf="ClientName && ClientName !== 'Choose Client' && ClientName !== ''">
                        <div class="text-container">
                           <span class="text">
                              Choose a module from the side menu
                              to unlock powerful data and actionable insights.
                           </span>
                        </div>
                        <div class="hero-search-wrapper" *ngIf="StudyName && StudyName !== 'Study Name' && StudyName !== 'Choose Study' && StudyName !== '' && isArkModuleActive">
                        <div class="hero-footer-search">
                           <div class="hero-search-input-wrapper" style="flex: 1; display: flex; align-items: center; min-width: 0;">
                             <input class="hero-footer-input" [(ngModel)]="inputValue" 
                                    (keyup.enter)="sendInputMessage()" type="text" 
                                    [placeholder]="isDictating ? 'Listening...' : 'Ask me anything...'" 
                                    style="flex: 1; margin: 0; padding-right: 12px; min-width: 0;" />
                                    
                             <!-- Dictation Mic -->
                             <div class="dictate-icon-wrapper" *ngIf="isSpeechSupported">
                                 <div class="dictate-icon" 
                                      [class.recording]="isDictating"
                                      (click)="toggleDictation()">
                                   <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 2a3 3 0 0 0-3 3v7a3 3 0 0 0 6 0V5a3 3 0 0 0-3-3Z"/><path d="M19 10v2a7 7 0 0 1-14 0v-2"/><line x1="12" x2="12" y1="19" y2="22"/></svg>
                                 </div>
                                 <div class="askme-custom-tooltip">
                                   <span class="d-title">Dictate</span>
                                   <span class="d-shortcut">Ctrl + Shift + D</span>
                                 </div>
                               </div>
                           </div>
                           
                           <div class="send-icon-wrapper">
                               <button class="hero-footer-send" type="button" (click)="sendInputMessage()" aria-label="Send"></button>
                               <div class="askme-custom-tooltip">
                                 <span class="d-title">Send</span>
                                 <span class="d-shortcut">Enter</span>
                               </div>
                             </div>
                        </div>
                           <div class="hero-footer-powered-by-container">
                              <span class="powered-text">Powered by</span>
                              <img src="../../../assets/images/explorerPlus/KaiA_Logo.svg" alt="KaiA_Logo" class="kaia-logo" />
                           </div>
                        </div>
                     </div>
                     <div class="static-txt" *ngIf="!ClientName || ClientName === 'Choose Client' || ClientName === ''">
                        <span class="text">
                           Choose a Client from the Left Corner
                           to unlock powerful data and actionable insights.
                        </span>
                     </div>
                  </div>
               </div>
            </div>
            <div class="moduleContent" *ngIf="isModuleSelected">
               <app-module-tile-landing
                  [moduleName]="moduleName"
                  [studyNames]="studyNames"
                  [studyName]="StudyName"
                  [ClientName]="ClientName"
                  [configData]="configData"
                  [isSuperAdmin]="isSuperAdmin"
                  [attr.data-key]="moduleKey">
               </app-module-tile-landing>
            </div>
            <div class="footer">
               <!-- <div class="kantar-logo">
                  <img src="assets/images/aesthetics/K_DSE_Logo.svg" alt="Kantar">
               </div> -->
            </div>
         </div>
      </div>
   </div>
</div>
<!-- <app-notification-panel
  [showNotification]="showNotification"
  [notifications]="notifications"
  [notificationCount]="notificationCount"
  [showClearAll]="showClearAll"
  (notificationClick)="onNotificationClick($event.notification, $event.event)"
  (clearAllClick)="clearAll($event)"
  (panelClick)="$event.stopPropagation()">
</app-notification-panel> -->

<app-notification-panel
  [(isOpen)]="showNotificationPanel"
  (notificationCountChange)="onNotificationCountChange($event)">
</app-notification-panel>

<app-report-issue-popup
   *ngIf="landingPageReportErrorPopupVisible"
   [landingMinimal]="true"
  [ClientName]="!ClientName || ClientName === 'Choose Client' ? 'N/A' : ClientName"
[StudyName]="!StudyName || StudyName === 'Study Name' ? '' : StudyName"
[SelectedModule]="'LANDING PAGE'"
   (closePopup)="landingPageReportErrorPopupVisible=false">
</app-report-issue-popup>